import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { useAppSettings } from "../../hooks/useAppSettings.tsx";
import { fetchPartnerByUser } from "../../services/application.service.ts";
import { Partner } from "../../models/Partner.ts";
import { setPartner as setPartnerInAuth } from "../../store/slices/authSlice.ts";
import S3Service from "../../services/s3.service.ts";
import { notification } from "../../utils/Notifications.tsx";
import Layout from "../../components/Layout.tsx";
import ProfileHeader from "../../components/profile/ProfileHeader.tsx";
import InformationUser from "../../components/profile/InformationUser.tsx";
import TimeLineDocuments from "../../components/profile/TimeLineDocuments.tsx";
import InformationPosition from "../../components/profile/InformationPosition.tsx";
import Contracts from "../../components/profile/Contracts.tsx";
import ProfilePartnerHeroCard from "../../components/profile/ProfilePartnerHeroCard.tsx";
import ProfilePersonalSummary from "../../components/profile/ProfilePersonalSummary.tsx";
import ProfilePartnerPanelSummary from "../../components/profile/ProfilePartnerPanelSummary.tsx";
import { useProfilePartnerLayoutStyles } from "../../components/profile/useProfilePartnerLayoutStyles.ts";
import { PROFILE_DEFAULT_TAB } from "../../components/profile/profileTabUtils.ts";

const MyExpedient = () => {
  const { user, token } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch();
  useAppSettings();
  useProfilePartnerLayoutStyles();
  const [error, setError] = React.useState<string | null>(null);
  const [loading, setLoading] = React.useState<boolean>(true);
  const [partner, setPartner] = React.useState<Partner>({} as Partner);
  const [files, setFiles] = React.useState({
    profile: "",
  });
  const [activeTabId, setActiveTabId] = React.useState(PROFILE_DEFAULT_TAB);

  const fetchPartner = async () => {
    setLoading(true);
    try {
      const response = await fetchPartnerByUser(Number(user.id));
      setPartner(response);
      dispatch(setPartnerInAuth(response));
      const profileUrl = await S3Service.getFile(
        "PERFIL_" + response.person.curp
      );
      setFiles({ profile: profileUrl.url });
    } catch (error) {
      setError(error?.message);
      notification(
        "Error",
        "Ocurrió un error al recuperar al colaborador",
        "danger"
      );
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    if (token) {
      fetchPartner();
    }
  }, [token]);

  if (error) return <>error</>;

  return (
    <Layout loading={loading}>
      {!loading && partner?.person && (
        <div id="content" className="app-content p-0">
          <div className="profile-content profile-content--partner p-0">
            <div className="profile-partner-layout">
              <div className="profile-partner-layout__left">
                <div className="profile-partner-identity-card">
                  <ProfilePartnerHeroCard
                    partner={partner}
                    profileUrl={files.profile}
                  />
                  <ProfilePartnerPanelSummary
                    partner={partner}
                    placement="identity"
                  />
                </div>
                <ProfilePersonalSummary
                  partner={partner}
                  onEdit={() => setActiveTabId("informacion")}
                  readOnly
                />
              </div>

              <div className="profile-partner-layout__right">
                <div className="profile-partner-panel">
                  <ProfilePartnerPanelSummary
                    partner={partner}
                    placement="panel"
                  />
                  <ProfileHeader
                    partner={partner}
                    activeTabId={activeTabId}
                    onTabSelect={setActiveTabId}
                  />
                  <div className="profile-partner-panel__body">
                    {activeTabId === "expediente" && (
                      <TimeLineDocuments
                        partner={partner}
                        reloadPage={() => fetchPartner()}
                        embedded
                      />
                    )}
                    {activeTabId === "informacion" && (
                      <InformationUser
                        partner={partner}
                        reloadPage={() => fetchPartner()}
                        disabled={true}
                        embedded
                      />
                    )}
                    {activeTabId === "empleo" && (
                      <InformationPosition
                        partner={partner}
                        reloadPage={() => fetchPartner()}
                        embedded
                      />
                    )}
                    {activeTabId === "contrato" && (
                      <Contracts partner={partner} embedded />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default MyExpedient;
